import { render, staticRenderFns } from "./tokenRejected.vue?vue&type=template&id=f870862c&"
import script from "./tokenRejected.vue?vue&type=script&lang=js&"
export * from "./tokenRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports